import { EntityConfig } from '../models/entity/entity.model';

export const entityConfig: EntityConfig = {
	USER: {
		controller: "/User",
		idDataset: "SPR_SEL_USUARIO",
		rootUrl: "/Usuario",
		itemKey: "Id_Usuario",
		listTitle: "Listagem de Usuários",
	},
	PROCESS: {
		controller: "/Process",
		idDataset: "SPR_SEL_PROCESS",
		rootUrl: "/Processo",
		itemKey: "Id_Processo",
		listTitle: "Listagem de Processos",
	}
};
